import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//comonents
import {
  Button,
  CurveHolder,
  StyledText,
} from "../../../components/common/basic";
import {
  Curve,
  CurveUp,
  DoneIcon,
  NewBackButton,
} from "../../../components/svgs";

// theme
import { useTheme, useLoyalty } from "../../../hooks";

const LoyaltyDescription = () => {
  const { themeContext, theme } = useTheme();
  const {
    loyaltyItem,
    selectedLoyaltyData,
    generateCoupon,
    activatedOffers,
    loyaltySuccessHeader,
    loyaltySuccessMessage,
    checkOffers,
    loyaltyCheckCode,
    generationComplete,
    setGenerationComplete,
    generatedCode,
    setGeneratedCode,
  } = useLoyalty();

  const history = useHistory();

  const [localLoyaltyData, setLocalLoyaltyData] = useState(null);
  const [activated, setActivated] = useState(undefined);

  const styles = generateStyles();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];

  useEffect(() => {
    const isActivated = findOffer(
      selectedLoyaltyData?.offerId,
      activatedOffers
    );

    if (isActivated) {
      setActivated(isActivated);
    }
  }, [activatedOffers]);

  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "LoyaltyDescription",
      firebase_screen_class: "LoyaltyDescription",
    }));
  }, []);

  // Initial page load
  useEffect(() => {
    if (selectedLoyaltyData) {
      setLocalLoyaltyData(selectedLoyaltyData);
      const strigifiedData = JSON.stringify(selectedLoyaltyData);
      window.localStorage.setItem("localLoyaltyData", strigifiedData);
    }
  }, []);

  //Subsequent page reload
  useEffect(() => {
    if (!localLoyaltyData) {
      const newData = JSON.parse(
        window.localStorage.getItem("localLoyaltyData")
      );
      setLocalLoyaltyData(newData);
    }
  }, []);

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  function findOffer(offerId, activatedOffers) {
    for (var i = 0; i < activatedOffers?.length; i++) {
      if (activatedOffers[i].name === offerId) {
        return activatedOffers[i];
      }
    }
  }

  const disableActivation = !localLoyaltyData?.active || activated;

  return (
    <MainHolder activeTheme={mashupBackground}>
      <Children>
        <BackButtonContainer
          onClick={() => {
            history.goBack();
          }}
        >
          <NewBackButton />
        </BackButtonContainer>
        <Image src={localLoyaltyData?.image} />
        {!generationComplete ? (
          <DescriptionBody color={mashupBackground}>
            <CurveHolder>
              <Curve fill={mashupBackground} />
            </CurveHolder>
            {generatedCode ||
              (activated && <StyledText>{"Your Discount Code:"}</StyledText>)}
            <Button
              onClick={(e) => {
                if (activated || disableActivation) {
                  stopPropagation(e);
                } else {
                  generateCoupon(localLoyaltyData?.activationId);
                }
              }}
              style={{ marginInline: 20 }}
              color={background}
              disabled={activated || disableActivation}
            >
              <StyledText color={activated ? background : "white"}>
                {generatedCode || activated
                  ? activated?.coupon
                  : `Get Discount code`}
              </StyledText>
            </Button>
            <ContentHolder>
              <StyledText
                size={18}
                fontFamily={"bold"}
              >{`How to Redeem your discount`}</StyledText>
              {localLoyaltyData?.steps.map((item, index) => {
                return (
                  <DescriptionItems key={index}>
                    <CircleContainer>
                      <ColorCircle color={background} />
                    </CircleContainer>
                    <StyledText size={12} style={styles.textStyle}>
                      {item}
                    </StyledText>
                  </DescriptionItems>
                );
              })}
              <StyledText
                size={10}
              >{`Your code expires after 30 days. You can only generate another code after it has been redeemed`}</StyledText>
            </ContentHolder>
          </DescriptionBody>
        ) : (
          <DescriptionBody color={mashupBackground}>
            <CurveHolder>
              <CurveUp fill={mashupBackground} />
            </CurveHolder>
            <DoneIconHolder>
              <DoneIcon fill={background} />
            </DoneIconHolder>
            <ContentHolder>
              <StyledText
                style={{ display: "flex", justifyContent: "center" }}
                size={20}
                fontFamily={"bold"}
              >
                {loyaltySuccessHeader}
              </StyledText>
              <StyledText size={13}>{loyaltySuccessMessage}</StyledText>
            </ContentHolder>
            <Button
              onClick={() => {
                setGenerationComplete(false);
                const token = JSON.parse(localStorage.getItem("token"));
                history.push(`/home?token=${token}`);
                if (loyaltyCheckCode) {
                  checkOffers(loyaltyCheckCode);
                }
              }}
              style={{ marginInline: 20, marginBlock: 20 }}
              color={background}
            >
              <StyledText color={"white"}>{`Great`}</StyledText>
            </Button>
          </DescriptionBody>
        )}
      </Children>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 360px;
`;

const ContentHolder = styled.div`
  margin-inline: 20px;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: 8px;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
`;

const ColorCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
`;

const DescriptionItems = styled.div`
  display: flex;
  align-items: center;
`;

const DoneIconHolder = styled.div`
  display: flex;
  align-items: center;
  margin-top: -90px;
  justify-content: center;
`;

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

export default LoyaltyDescription;
